import { render } from "./FolderCreateModal.vue?vue&type=template&id=b2157820"
import script from "./FolderCreateModal.vue?vue&type=script&lang=js"
export * from "./FolderCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__